import { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext({
    theme: 'dark',
    setTheme: () => {},
    resolvedTheme: 'dark',
});

export function ThemeProvider({ children }) {
    const [resolvedTheme] = useState('dark');

    useEffect(() => {
        const root = document.documentElement;
        root.classList.add('dark');
    }, []);

    const setTheme = () => {};

    return (
        <ThemeContext.Provider value={{ theme: 'dark', setTheme, resolvedTheme }}>
            {children}
        </ThemeContext.Provider>
    );
}

export function useTheme() {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
}
